<template>
  <div class="looking_site">
    <van-sticky>
      <van-nav-bar title="账号设置" left-arrow @click-left="goback()" />
    </van-sticky>

    <div class="site_form">
      <van-form
        label-width="100"
        :show-error="false"
        @submit="onSubmit"
        error-message-align="right"
      >
        <van-cell-group>
          <van-field input-align="right" label="头像" readonly>
            <template #button>
              <van-uploader
                :max-count="1"
                v-model="uploader"
                :after-read="afterRead"
                accept="image/*"
              />
            </template>
          </van-field>
          <van-field
            
            input-align="right"
            v-model="submitData.nickname"
            label="昵称"
            placeholder="请输入"
            is-link
          />
          <van-field
            input-align="right"
            v-model="submitData.fullName"
            label="姓名"
            placeholder="请输入"
            is-link
          />
          <van-field
            input-align="right"
            v-model="submitData.gender_name"
            label="性别"
            placeholder="请选择"
            is-link
            @click="showSexsOptions = true"
          />
          <van-field
            input-align="right"
            v-model="submitData.birth"
            label="生日"
            placeholder="请输入"
            is-link
            readonly
            @click="showTime = true"
          />
          <van-field
            is-link
            input-align="right"
            v-model="submitData.contactNumber"
            label="联系电话"
            placeholder="请输入"
          />
          <van-field
            input-align="right"
            v-model="submitData.emergencyContactName"
            label="紧急联系人"
            placeholder="请输入"
            is-link
          >
          </van-field>
          <van-field
            is-link
            input-align="right"
            v-model="submitData.emergencyContactPhone"
            label="紧急联系电话"
            placeholder="请输入"
          />
          <van-field
            input-align="right"
            v-model="submitData.telephone"
            label="登录账号"
            placeholder="请输入"
            is-link
            disabled
          >
          </van-field>
          <van-field
            required
            input-align="right"
            v-model="submitData.password"
            label="登录密码"
            placeholder="请输入"
            is-link
            :rules="[{ required: true, message: '请输入密码' }]"
          >
          </van-field>
          <van-field
            input-align="right"
            v-model="submitData.openid"
            label="绑定微信号"
            placeholder="点击授权绑定"
            is-link
            readonly
            @click="wxPayAuthorize"
          >
          </van-field>
        </van-cell-group>
        <div class="form_btn">
          <van-button block color="#0CA7F0" type="info" native-type="submit"
            >保存设置</van-button
          >
        </div>
      </van-form>
    </div>

    <van-action-sheet
      v-model="showSexsOptions"
      :actions="sexsOptions"
      @select="onSelectType"
    />
    <van-action-sheet v-model="showTime">
      <van-datetime-picker
        type="date"
        title="请选择生日时间"
        :min-date="minDate"
        :max-date="maxDate"
        @change="changeShowTime"
        @confirm="confirmShowTime"
        :formatter="formatter"
        @cancel="showTime = false"
      />
    </van-action-sheet>
  </div>
</template>
<script>
import { Button } from "vant";
import { NavBar } from "vant";
import { Form, Field, CellGroup } from "vant";
import { RadioGroup, Radio } from "vant";
import { Icon } from "vant";
import { ActionSheet, Cascader, Popup, Uploader, DatetimePicker } from "vant";
import storage from "@/utils/storage";

export default {
  components: {
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    [Form.name]: Form,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Icon.name]: Icon,
    [ActionSheet.name]: ActionSheet,
    [Cascader.name]: Cascader,
    [Popup.name]: Popup,
    [Uploader.name]: Uploader,
    [DatetimePicker.name]: DatetimePicker,
  },
  data() {
    return {
      submitData: {
        nickname: "",
        fullName: "",
        gender: "",
        telephone: "",
        password: "",
        birth: "",
        contactNumber: "",
        emergencyContactName: "",
        emergencyContactPhone: "",
        openid: "",
        uploadfile: "",
      },
      uploader: [{ url: "https://img01.yzcdn.cn/vant/leaf.jpg" }],
      //性别
      showSexsOptions: false,
      sexsOptions: [],

      minDate: new Date(1960, 0, 0),
      maxDate: new Date(),
      currentDate: new Date(2000, 0, 0),
      showTime: false,
      confirmTime: "",
      codeValue: "",
    };
  },

  created() {
    //账号设置-查看
    this.changePortraitDetail();
    //员工管理-性别列表
    this.employeeManagementAdd();

    if (storage.getCode() == "" && this.GetQueryString('code') != null) {
      this.codeValue = this.GetQueryString('code')
      storage.setCode(this.codeValue)
      this.wxPayAuthorize()
    }
    if (storage.getCode() != "" && storage.getCode() != this.GetQueryString('code') && this.GetQueryString('code') != null) {
      this.codeValue = this.GetQueryString('code')
      storage.setCode(this.codeValue)
      this.wxPayAuthorize()
    }

  },

  methods: {

    GetQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },

    //账号设置-绑定微信号
    wxPayAuthorize() {
      let that = this;
      if (that.submitData.openid != "") {
        that.$Notify({
          type: "danger",
          message: "请勿重复绑定",
        });
        return false;
      }

      let appid = "wx011d015cfd81deca";
      if (that.isWeiXin()) {
        const code = that.codeValue;
        if (code == null || code === "") {
          let url = window.location.href;
          url = "http://tgy.1688tg.com/mobile/#/personal/setting?access_token="+storage.getToken();
          let reditUrl =
            "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
            appid +
            "&redirect_uri=" +
            encodeURIComponent(url) +
            "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect";
          window.location.href = reditUrl;
          console.log(reditUrl);
        }
        that.getWechatAccessToken(code);
      } else {
        that.$Notify({
          type: "danger",
          message: "请使用微信浏览器打开",
        });
      }
    },

    // 判断是否是微信浏览器
    isWeiXin() {
      let ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },

    //获取微信回调信息
    getWechatAccessToken(code) {
      var that = this;
      that.$api
        .getWechatAccessToken({
          code: code,
          state: 1,
        })
        .then(function (res) {
          console.log('getWechatAccessToken',res)
          if (res.data.code === 200) {
            that.getWechatUserInfo(
              res.data.data.access_token,
              res.data.data.openid
            );
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },

    //拉取微信用户信息
    getWechatUserInfo(wx_access_token, openid) {
      var that = this;
      that.$api
        .getWechatUserInfo({
          wx_access_token: wx_access_token,
          openid: openid,
        })
        .then(function (res) {
          console.log('getWechatUserInfo',res)
          if (res.data.code === 200) {
            that.submitData.openid = res.data.data.openid;
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },

    //文件读取完回调函数
    afterRead(files) {
      var that = this;
      files.status = 'uploading';
      files.message = '上传中...';
      const fromdata = new FormData();
      fromdata.append("uploadfile", files.file);
      that.$axios
        .post(
          process.env.API_ROOT + "tgy/mobile/user/changePortrait",
          fromdata,
          {
            headers: {
              enctype: "multipart/form-data",
              Authorization: storage.getUserInfo(),
            },
          }
        )
        .then((res) => {
          if (res.data.code === 200) {
            files.status = 'done';
            files.message = '上传成功';
            that.$Notify({
              type: "success",
              message: "上传成功",
              onClose() {
                //账号设置-查看
                that.changePortraitDetail();
              },
            });
          }
          console.log(res.data);
        });
    },

    onSubmit() {
      var that = this;
      that.$api
        .personalSettingsSaveAPI(that.submitData)
        .then(function (res) {
          if (res.data.code === 200) {
            that.$Notify({
              type: "success",
              message: "保存成功",
            });
            setTimeout(()=>{
              that.$router.push({ path: "/" });
            },500)
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },

    // 员工管理-性别列表
    employeeManagementAdd() {
      var that = this;
      that.$api
        .employeeManagementAddAPI("")
        .then(function (res) {
          if (res.data.code === 200) {
            var genderList = res.data.data.genderList;
            genderList.forEach((element) => {
              element.value = element.itemId;
              element.name = element.itemText;
            });
            that.sexsOptions = genderList;
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },

    formatter(type, val) {
      if (type === "year") {
        return `${val}`;
      } else if (type === "month") {
        return `${val}`;
      } else if (type === "day") {
        return `${val}`;
      }
      return val;
    },

    changeShowTime(picker) {
      var time = picker.getValues();
      this.confirmTime = time[0] + "-" + time[1] + "-" + time[2];
    },

    confirmShowTime() {
      var that = this;
      setTimeout(function () {
        that.submitData.birth = that.confirmTime;
        that.showTime = false;
      }, 500);
    },

    // 选中类型
    onSelectType(item) {
      this.submitData.gender = item.value;
      this.submitData.gender_name = item.name;
      this.showSexsOptions = false;
    },

    //账号设置-查看
    changePortraitDetail() {
      var that = this;
      that.$api
        .changePortraitDetailAPI(that.params)
        .then(function (res) {
          if (res.data.code === 200) {
            // 处理微信授权数据
            if (res.data.data.openid === "") {
              res.data.data.authorization = "点击一键绑定微信号";
            } else {
              res.data.data.authorization = "已绑定微信号";
            }

            that.uploader[0].url = res.data.data.portrait;
            that.submitData = res.data.data;
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },

    //返回上一页
    goback() {
      if (window.history.length <= 1) {
        this.$router.push({ path: "/" });
        return false;
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.looking_site {
  display: flex;
  flex-direction: column;

  .site_form {
    padding: 0px 10px;
    height: auto;

    /deep/ .van-uploader__upload {
      width: 50px;
      height: 50px;
    }

    /deep/ .van-uploader__preview-image {
      width: 50px;
      height: 50px;
    }

    /deep/ .van-cell {
      align-items: center !important;
    }

    .form_tag {
      display: flex;
      justify-content: space-between;
      padding: 0px 20px;
    }

    .van-cell {
      display: flex;
      align-items: flex-start;
    }

    .form_feature {
      color: #646566;
      margin: 15px 10px;

      .fs28::after {
        position: absolute;
        left: 110px;
        color: #ee0a24;
        margin-top: 8px;
        font-size: 8px;
        content: "*";
      }

      .van-button {
        height: 35px;
        margin-top: 15px;
        margin-right: 15px;
      }
    }
  }

  .form_btn {
    margin: 50px 10px;
    border-radius: 1000px;

    .van-button {
      height: 44px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/personal/setting.vue